<aor-indicator
  [recessionData]="config"
  class="aor-tool"
  [brLabels]="brLabels"
></aor-indicator>
